// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './plugins/element.js'
import ElementUi from 'element-ui'
var qs=require('qs');
import axios from './utils/axios.js'
Vue.filter('date',(date)=>{
  date = new  Date(date)
  return formatDate(date,'yyyy-MM-dd hh:mm:ss')
})
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUi)
Vue.config.productionTip = false
Vue.prototype.$axios=axios
Vue.prototype.$qs=qs
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js